export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2019.8e6e87a5.pdf";